import { render, staticRenderFns } from "./TechnicalResources.vue?vue&type=template&id=318c2659&"
import script from "./TechnicalResources.vue?vue&type=script&lang=js&"
export * from "./TechnicalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports